<template>
  <div class="settings">
    <v-container fluid>
      <h1 class="mb-3">Agent Keyword Filter</h1>
      <div class="card-curvey">

        <v-combobox
          v-model="words"
          :items="[]"
          chips
          outline
          solo
          multiple
          @input="updateBadWords"
        >
          <template v-slot:selection="data">
            <v-chip
              :selected="data.selected"
              close
              @input="removeTerm(data.item)"
            >
              <strong>{{ data.item }}</strong>&nbsp;
            </v-chip>
          </template>
        </v-combobox>
      </div>
    </v-container>
  </div>
</template>

<script>
  import common from "../../../utils/common";

  export default {
    name: "badWords",
    data () {
      return {
        words: []
      }
    },
    mounted() {
      this.getBadWords()
    },
    methods: {
      getBadWords () {
        this.$http_session_manager.get(`/bad-words/${this.$store.state.bot.botId}`)
        .then(response=>{
          if (response.data) {
            this.words = response.data.words
          }
        })
        .catch(error=>{
          if (error.response && error.response.status === 401) {
            common.logOut()
          } else {
            this.$store.dispatch('setErrorMessage', true)
          }
        })
      },
      updateBadWords () {
        this.$http_session_manager.post(`bad-words`, {
          bot_id: this.$store.state.bot.botId,
          words: this.words
        })
          .then(response=>{
            if (response.data) {

            }
          })
          .catch(error=>{
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', true)
            }
          })
      },
      removeTerm(term){
        let index = this.words.indexOf(term)
        this.words.splice(index,1)
        this.updateBadWords()
      },
    }
  }
</script>

<style scoped>

</style>
